export const environment = {
  production: false,
  environmentLabel: '',
  server: 'https://julqa.nsw.pt/',
  julWebServer: 'https://julqa.nsw.pt/jul-web/',
  gadUrl: 'https://julqa.nsw.pt/gad-services/api',
  serverUrl: 'https://julqa.nsw.pt/gad-services/api',
  serverUrlNotifier: 'https://julqa.nsw.pt/notifier-services/api',
  logoutUrl: 'https://julqa.nsw.pt',
  loginUrl: 'https://julqa.nsw.pt',
  coreServer: 'https://julqa.nsw.pt/jul-web', 
  serverUrlRTM: 'https://julqa.nsw.pt/rtm-services/api',
  serverUrlSummary: 'https://julqa.nsw.pt/summary-services/api',
  serverUrlMD: 'https://julqa.nsw.pt/md-services/api',
};
